// DS: i3.38
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const CreateVariations = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M11 1a1 1 0 100 2h.389L8.046 6H2a1 1 0 100 2h6.811L13 4.241V5a1 1 0 102 0V1.8a.8.8 0 00-.8-.8H11zm.207 8.793a1 1 0 00-1.414 1.414L11.586 13H11a1 1 0 100 2h3.2a.8.8 0 00.8-.8V11a1 1 0 10-2 0v.586l-1.793-1.793z"
    })));
};
CreateVariations.displayName = 'CreateVariations';
export default CreateVariations;

//# sourceMappingURL=CreateVariations.js.map